const { doAction, fail, success } = require('./index');

const FAILED_FETCH_MESSAGE =
	'Failed to retrieve the list of grade levels from the server';
const FETCHED_GRADE_LEVELS = 'FETCHED_GRADE_LEVELS';
const FETCHING_GRADE_LEVELS = 'FETCHING_GRADE_LEVELS';

const url = '/api/grade_levels';

module.exports = {
	FAILED_FETCH_MESSAGE,
	FETCHED_GRADE_LEVELS,
	FETCHING_GRADE_LEVELS,

	fetchGradeLevels() {
		const method = 'get';
		const payload = null;
		const doingActionType = FETCHING_GRADE_LEVELS;
		const didActionType = FETCHED_GRADE_LEVELS;
		const failureMessage = FAILED_FETCH_MESSAGE;

		return doAction(
			url,
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage
		);
	}
};



// WEBPACK FOOTER //
// ./frontend/a2i/js/actions/gradeLevels.js